import React from 'react';
import { AppFeature } from '@types';
// Import images using ES Modules
import halfLemonsImage from '@images/half-lemons.png';
import swinkImage from '@images/swink.png';
import dinnersAppImage from '@images/dinners-app.png';
import changeReelImage from '@images/change-reel.png';
import streakPulseImage from '@images/streak-pulse.png';
import thinkGloballyImage from '@images/think-globally.jpg';
import gainsImage from '@images/gains.png';

// Define features data
const appFeatures: AppFeature[] = [
  {
    id: 'half-lemons',
    title: 'Half Lemons',
    image: halfLemonsImage,
    imageAlt: 'Half Lemons iOS App by Theo Goodman - Find recipes using your ingredients.',
    description: 'Recipes using your ingredients.',
    link: 'https://www.halflemons.com',
    linkText: 'www.halflemons.com'
  },
  {
    id: 'swink',
    title: 'Swink',
    image: swinkImage,
    imageAlt: 'Swink is an iOS & Android App by Theo Goodman - Find new tennis partners.',
    description: 'Find new tennis partners.',
    link: 'https://swinktennis.com',
    linkText: 'www.swinktennis.com'
  },
  {
    id: 'gains',
    title: 'Gains',
    image: gainsImage,
    imageAlt: 'Gains Clothing by Theo Goodman - Gains apparel.',
    description: 'Fitness apparel.',
    link: 'https://gainsapparel.netlify.app',
    linkText: 'gainsapparel.netlify.app'
  },
  {
    id: 'change-reel',
    title: 'Change Reel',
    image: changeReelImage,
    imageAlt: 'Change Reel by Theo Goodman - Product Comms Automated',
    description: 'AI-powered Release Notes.',
    link: 'https://www.changereel.com',
    linkText: 'www.changereel.com'
  },
  {
    id: 'dinners-app',
    title: 'Dinners App',
    image: dinnersAppImage,
    imageAlt: 'Dinners App by Theo Goodman - Tinder-style recipe matching app.',
    description: 'Tinder for recipes.',
    link: 'https://www.dinnersapp.com',
    linkText: 'www.dinnersapp.com'
  },
  {
    id: 'think-globally',
    title: 'Think Globally, Live Locally',
    image: thinkGloballyImage,
    imageAlt: 'Think Globally Live Locally by Theo Goodman - Curated travel guide platform',
    description: 'Curated travel guide.',
    link: 'https://www.thinkgloballylivelocally.com',
    linkText: 'www.thinkgloballylivelocally.com'
  },
  {
    id: 'streak-pulse',
    title: 'Streak Pulse',
    image: streakPulseImage,
    imageAlt: 'Streak Pulse iOS App by Theo Goodman - Gamified task management and habit tracking',
    description: 'Gamify your habits.',
    link: 'https://www.streakpulse.com',
    linkText: 'www.streakpulse.com'
  },
];

const AppFeatures: React.FC = () => {
  return (
    <div>
      <h3 className="text-lg font-light text-black mb-4">My Projects</h3>
      <div className="rounded-lg pl-4 sm:pl-0">
        <div className="grid grid-cols-2 sm:gap-16 gap-8">
          {appFeatures.map((feature) => (
            <div key={feature.id} className="flex flex-col sm:flex-row sm:items-center">
              <div className="sm:ml-6 w-full">
                <a href={feature.link} className="block" target="_blank" rel="noopener noreferrer">
                  <img src={feature.image} 
                       alt={feature.imageAlt} 
                       className="sm:w-full aspect-square object-contain rounded-xl transition-transform duration-900 sm:hover:scale-105" />
                </a>

                <h4 className="text-base sm:text-sm font-light text-black break-words sm:whitespace-nowrap">{feature.title}</h4>
                <p className="text-gray-500 text-sm font-light mb-1 -mt-1 break-words sm:whitespace-nowrap">
                  {feature.description}
                  {feature.id === 'gains' && <span className="block sm:hidden">&nbsp;</span>}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppFeatures;